<template>
    <span class="custom-toolbar">
<!-- TITLE ONLY -->
        <v-toolbar v-if="type === 'only-title'" dense>
            <div class="d-flex py-4 central-toolbar">
                <h1 class="py-4">{{title}}</h1>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- BACK ARROW - TITLE -->
        <v-toolbar v-if="type === 'back-arrow'" dense>
            <div class="d-flex py-4 central-toolbar">
                <v-btn :to="linkback" icon class="back-arrow">
                    <v-icon color="black">mdi-arrow-left</v-icon>
                </v-btn>
                <h1 class="py-4">{{title}}</h1>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- OPERATIONS - ACTIONS COLLABORATIVES -->
        <v-toolbar v-if="type === 'operations-action-collaborative'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex">
                    <div>
                        <h1 class="py-4">{{title}}</h1>
                    </div>
                    <div class="d-flex toolbar-options">
                        <div class="d-flex ma-auto">
                            <v-select v-model="status" :items="statuses" :item-value="'value'" :item-text="'text'" @change="$emit('status-change', $event)" placeholder="Statut" append-icon="mdi-chevron-right" class="mr-6">
                                <template v-slot:item="{item}">
                                    <p :class="['status-option', item.text.trim().toLowerCase().replaceAll(' ','-')]">{{item.text}}</p>
                                </template>
                            </v-select>
                        </div>
                        <div class="my-auto">
                            <v-btn icon>
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn icon>
                                <v-icon>mdi-tune-vertical</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- GESTION DES POINTS -->
        <v-toolbar v-if="type === 'gestion-points'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex">
                    <div>
                        <h1 class="py-4">{{title}}</h1>
                    </div>
                    <div class="d-flex toolbar-options">
                        <div class="d-flex ma-auto">
                            <v-select :value="defaultGestionPoints" :items="pointsManagement" :item-text="'text'" :item-value="'value'" @change="$emit('status-change', $event)" append-icon="mdi-chevron-right" outlined class="mr-6">
                                <template v-slot:item="{item}">
                                    <p :class="['status-option', item.text.trim().toLowerCase().replaceAll(' ','-')]">{{item.text}}</p>
                                </template>
                            </v-select>
                        </div>
                        <div class="my-auto">
                            <v-btn icon>
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn icon>
                                <v-icon>mdi-tune-vertical</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- GESTION DE BAIL, GESTION DES ANNONCES, INTERVENTIONS -->
        <v-toolbar v-if="type === 'statut-selector'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex">
                    <div>
                        <h1 class="py-4">{{title}}</h1>
                    </div>
                    <div class="d-flex toolbar-options">
                        <div class="d-flex ma-auto">
                            <v-select v-model="status" :items="statuses" :item-value="'value'" :item-text="'text'" @change="$emit('status-change', $event)" placeholder="Statut" append-icon="mdi-chevron-right" class="mr-6">
                                <template v-slot:item="{item}">
                                    <p :class="['status-option', item.text.trim().toLowerCase().replaceAll(' ','-')]">{{item.text}}</p>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- ENQUETES -->
        <v-toolbar v-if="type === 'enquetes'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex flex-column align-flex-start">
                    <div class="d-flex mobile-space-between">
                        <h1 class="py-4">{{title}}</h1>
                        <div class="ma-auto">
                            <v-btn icon>
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn icon>
                                <v-icon>mdi-tune-vertical</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div class="d-none flex-column">
                        <h2 class="pa-0">Enquête(s) publiée(s) : 1</h2>
                        <h2 class="pa-0">Enquête(s) en brouillon : 1</h2>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- RESULTATS ENQUETES ET ACTIONS COLLABORATIVES -->
        <v-toolbar v-if="type === 'results'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex">
                    <div class="d-flex">
                        <v-btn :to="linkback" icon class="back-arrow">
                            <v-icon color="black">mdi-arrow-left</v-icon>
                        </v-btn>
                        <h1 class="py-4  mr-6">{{title}}</h1>
                    </div>
                    <div class="d-flex">
                        <v-btn icon to='/enquetes/resultat'>
                            <v-icon>mdi-chart-bar</v-icon>
                        </v-btn>
                        <v-btn icon to='/enquetes/resultat/detail'>
                            <v-icon>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div class="d-none flex-column">
                    <h2 class="pa-0">Enquête(s) publiée(s) : 1</h2>
                    <h2 class="pa-0">Enquête(s) en brouillon : 1</h2>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- LOCATAIRES -->
        <v-toolbar v-if="type === 'tenants'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex flex-column">
                    <div class="d-flex mobile-space-between">
                        <h1 class="py-4">{{title}}</h1>
                        <div class="my-auto">
                            <v-btn icon>
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn icon>
                                <v-icon>mdi-tune-vertical</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div class="d-none flex-column">
                        <h2 class="pa-0">Nombre de locataires : 32465</h2>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- ANNUAIRE DES INTERVENANTS -->
        <v-toolbar v-if="type === 'directory'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex flex-column">
                    <div class="d-flex mobile-column">
                        <h1 class="py-4">{{title}}</h1>
                        <div class="my-auto">
                            <div class="mobile-float-right">
                                <v-btn icon>
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon>mdi-tune-vertical</v-icon>
                                </v-btn>
                                <v-btn icon :to="linkplusicon">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="d-none flex-column">
                        <h2 class="pa-0">Nombre d'intervenants : 324</h2>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
<!-- COMPTES -->
        <v-toolbar v-if="type === 'accounts'" dense>
            <div class="d-flex flex-column central-toolbar">
                <div class="d-flex flex-column">
                    <div class="d-flex mobile-column">
                        <h1 class="py-4">{{title}}</h1>
                        <div class="my-auto">
                            <div class="mobile-float-right">
                                <v-btn icon>
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon>mdi-tune-vertical</v-icon>
                                </v-btn>
                                <v-btn icon :to="linkplusicon">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-center justify-space-between account">
                <p class="mb-0">Bonjour Jean-Christophe !</p>
                <img src="/images/account.png" alt="">
            </div>
        </v-toolbar>
    </span>
</template>


<script>
export default {
  name: 'ToolBar',
  props: ['type', 'title', 'linkback', 'linkplusicon', 'text1', 'text2', 'number1', 'number2', 'defaultGestionPoints'],
  data: () => ({
    status: {
        text: 'En cours',
        value: false
    },
    statuses: [
        {
            text: 'En cours',
            value: false
        },
        {
            text: 'Terminées',
            value: true
        }
    ],
    pointsManagement: [
        {
            text: 'Loterie',
            value: '/loterie'
        },
        {
            text: 'Catalogue',
            value: '/catalogue'
        }
    ]
  })
}
</script>